import $ from 'jquery'

const size = {
   
     screenSize: $(window).width(),
     
     isMobile: () => $(window).width() <= 600


}

export default size